import React, { useState } from "react";

import "./stylesDashboardLineChart.css";
import { formatNumber } from "chart.js/helpers";

import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
} from "chart.js";
import RebetLoader from "../../RebetLoader/RebetLoader";
import { Skeleton } from "antd";
import CustomDatePicker from "../../DatePicker/DatePicker";

function DashboardLineChart({
  headers,
  title,
  data,
  setSelected,
  rightInfo = true,
  configOptions,
  isApiRunning = false,
  getData,
  dates,
  setDates,
  showQuickSelect = false,
  showPresets = false,
  customOptions = false,
  showCustomDatePicker = false,
}) {
  const [activeIndex, setActiveIndex] = useState(0);

  const handeSetActiveIndex = (title, index) => {
    setActiveIndex(index);
    setSelected(title);
  };

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        enabled: true,
        mode: "nearest",
        intersect: false,
        callbacks: {
          label: function (context) {
            const value = context.raw;
            return `${context.dataset.label}: ${formatNumber(
              value,
              "en-US",
              "decimal",
              2
            )}\n`;
          },
        },
        backgroundColor: "#25252F",
        titleFont: {
          family: "Poppins-regular",
          size: 16,
          weight: "bold",
        },
        bodyFont: {
          family: "Poppins-regular",
          size: 14,
        },
        padding: 20,
        displayColors: true,
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            if (value > 1000) {
              return value / 1000 + "k";
            } else {
              return value;
            }
          },
        },
      },
    },
    interaction: {
      mode: "index", // Show tooltip for all datasets at hovered index
      intersect: false,
      axis: "x", // Ensure crosshair lines show on the x-axis
    },
  };

  return (
    <div id="dashboard-line-chart">
      <div className="dashboard-line-chart-header-container">
        <div className="dashboard-line-chart-header">
          {headers.map((kpi, index) => (
            <div
              key={index}
              className={`dashboard-line-chart-kpi ${
                activeIndex === index ? "active" : ""
              }`}
              onClick={() => handeSetActiveIndex(kpi.title, index)}
            >
              <div className="dashboard-line-chart-kpi-title">{kpi.title}</div>
              {isApiRunning ? (
                <div style={{ marginTop: 20 }}>
                  <Skeleton.Button
                    active={1}
                    size={10}
                    shape={"default"}
                    block={false}
                  />
                </div>
              ) : (
                <div className="dashboard-line-chart-kpi-value">
                  {formatNumber(kpi.amount, "en-US", {
                    style: "decimal",
                    maximumFractionDigits: 2,
                  })}
                </div>
              )}
            </div>
          ))}
          {title && <h3>{title}</h3>}
        </div>
        {showCustomDatePicker && (
        <CustomDatePicker
          getData={getData}
          dates={dates}
          setDates={setDates}
          showQuickSelect={showQuickSelect}
              showPresets={showPresets}
          />
        )}
      </div>

      <div className="dashboard-line-chart-body">
        {isApiRunning ? (
          <RebetLoader width={100} height={100} />
        ) : (
          <>
            <div className="left-content">
              <Line data={data} options={options} />
            </div>
            <div
              className="right-content"
              style={{ display: rightInfo ? "flex" : "none" }}
            >
              {data.datasets.map((dataset, index) => {
                return (
                  <div className="stat" key={index}>
                    <div className="stat-title">
                      <div
                        className="circle"
                        style={{ backgroundColor: dataset.borderColor }}
                      ></div>
                      {dataset.label}
                    </div>
                    <div className="stat-value">
                      {formatNumber(dataset.sum, "string", {
                        style: "decimal",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default DashboardLineChart;
